<div class="footer-container">
  <footer id="footer" class="footer">
    <div class="footerOsaic">
      <div class="footer-left">
        <p><span class="big-contact">Contact:</span><br/>
          <!--{{"copy.html.Footer.email" | copy | async}}-->
          <a class="mt-1" href="mailto:meetings@osaic.com">meetings&#64;osaic.com</a>
        </p>
        <img class="img-fluid" src="assets/images/Osaic-Logo-Evergreen.svg" alt="Osaic Logo">
      </div>
      <div class="footer-right">
        <div class="container">
          <!-- Maritz -->
          <div class="footerMaritz">
            <div class="text-left">
                <a tabindex="0" (click)="openModal('termsOfUse', 'About This Site', 'Close');"  (keydown.enter)="openModal('termsOfUse', 'About This Site', 'Close');"  rel="noopener noreferrer">
                  {{"copy.label.FOOTER.termsofuse" | copy | async}}
                </a>
                <span>&#8226;</span>
                <a tabindex="0" href="https://osaic.com/disclosures/privacy-policy" target="_blank" rel="noopener noreferrer">
                  {{"copy.label.FOOTER.privacy" | copy | async}}
                </a>
                <span>&#8226;</span>
                <!-- <a tabindex="0" (click)="openModalExternal('https://mge-cdn.prodtravelhq.com/policies/mge_cookie_policy.html', 'Cookie Policy', 'Close')" (keydown.enter)="openModalExternal('https://mge-cdn.prodtravelhq.com/policies/mge_cookie_policy.html', 'Cookie Policy', 'Close')">
                  Cookie Policy
                </a> -->
                <!-- OneTrust Cookies Settings button start -->
                <a tabindex="0" class="ot-sdk-show-settings" id="cookieSettings" tabindex="0" (keyup.enter)="cookieEnter()">Cookie Settings</a>
                <!-- OneTrust Cookies Settings button end -->
              </div>
              <div class="text-left mt-2">
                <a href="https://maritz.com" target="_blank" rel="noopener noreferrer"
                  >Powered by <span class="sr-only">Maritz</span> <svg class="svg-fill mtlogo" aria-hidden="true">
                    <use xlink:href="assets/images/maritz-logo.svg#maritz"></use>
                  </svg></a>
              </div>
          </div>
          <!-- Osaic -->
          <div>
            <p>
              Securities and investment advisory services are offered through the firms: Osaic Wealth, Inc., Osaic Institutions, Inc., Osaic FA, Inc., and Osaic FS, Inc. broker-dealers, registered investment advisers, and members of FINRA and SIPC. Securities are offered through Ladenburg Thalmann & Co., broker-dealer and member of FINRA and SIPC. Advisory services are offered through Arbor Point Advisors, LLC, Ladenburg Thalmann Asset Management, Inc., and Osaic Advisory Services, LLC., registered investment advisers. Advisory programs offered by Osaic Wealth, Inc. are sponsored by VISION2020 Wealth Management Corp., an affiliated registered investment adviser.</p>
            <p>
              &copy; Osaic, Inc. &#8226; <a href="https://www.osaic.com" target="_blank" rel="noopener noreferrer">osaic.com</a> 6865379
            </p>
          </div>
        </div>
      </div>
  </div>
  </footer>
</div>
